<template>
  <div class="col-12">
    <div class="card mb-5 " style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">
              {{ t('groups.addNew') }}
            </h6>
          </div>
        </div>
      </div>
    
      <div class="card-body px-0 pb-2 pe-3">
        <div class="row justify-content-center">
          <div class="col-md-6 ms-3">
            <GroupForm 
              ref="groupForm"
              @submit="handleSubmit" 
              @cancel="handleCancel"
              @validation-error="handleValidationError"
            />
            
            <div class="d-flex gap-3 mt-3">
              <button 
                type="button" 
                class="btn btn-primary btn-sm flex-grow-1"
                @click="submitForm"
                :disabled="isSubmitting"
              >
                <span v-if="isSubmitting">
                  <i class="fas fa-spinner fa-spin me-2"></i>
                  {{ t('groups.adding') }}
                </span>
                <span v-else>
                  <i class="fas fa-plus ms-2"></i>
                  {{ t('groups.add') }}
                </span>
              </button>
              <button 
                type="button" 
                class="btn btn-outline-secondary btn-sm flex-grow-1"
                @click="handleCancel"
                :disabled="isSubmitting"
              >
                <i class="fas fa-times ms-2"></i>
                {{ t('groups.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useToast } from 'vue-toastification';
import GroupForm from '@/components/features/groups/forms/GroupForm.vue';

const { t } = useI18n();
const toast = useToast();
const router = useRouter();
const store = useStore();

const groupForm = ref(null);
const isSubmitting = ref(false);

const handleSubmit = async (formData) => {
  isSubmitting.value = true;
  try {
    await store.dispatch('groups/createGroup', formData);
    toast.success(t('groups.addedSuccessfully'));
    router.push('/groups');
  } catch (error) {
    if (error.response?.data?.errors) {
      groupForm.value.setServerErrors(error.response.data.errors);
    }
    toast.error(error.response?.data?.message || error.message || t('groups.addFailed'));
  } finally {
    isSubmitting.value = false;
  }
};

const submitForm = () => {
  groupForm.value.submit();
};

const handleValidationError = () => {
  toast.warning(t('groups.validationError'));
};

const handleCancel = () => {
  if (!isSubmitting.value) {
    router.push('/groups');
  }
};
</script>
